import ng_en_US from '@angular/common/locales/en';
import ng_fr_FR from '@angular/common/locales/fr';
import { fr_FR, en_US } from 'ng-zorro-antd/i18n';
import { ICwtCoreConfig, CwtDeepPartial } from '@cawita/core-front';
import * as models from '@shared/models';
import { environment } from '../../environments/environment';
import { CwtDefaultAuthConfig } from '@cawita/core-front/auth';
import { NzConfig } from 'ng-zorro-antd/core/config';

export const CompanyCoreConfig: CwtDeepPartial<ICwtCoreConfig> = {
    api: {
        apiUrl: environment.apiUrl,
        models: Object.values(models) as any[],
    },
    asset: {
        assetUrl: environment.assetUrl,
        protectedAssetPath: environment.protectedAssetPath,
        publicAssetPath: environment.publicAssetPath,
    },
    auth: {
        stateStorageKey: 'cwt-company-auth',
        api: {
            ...CwtDefaultAuthConfig?.api,
            registerEndpoint: 'user/subscribe'
        },
        navigation: {
            defaultRoute: ['/'],
            permissionDeniedRoute: ['/'],
            loginRoute: ['/'],
        },
    },
    i18n: {
        currentLocaleStorageKey: 'cwt-cca-company-locale',
        defaultCurrencyCode: 'EUR',
        defaultLocale: 'fr',
        locales: [
            { localeId: 'fr', localeName: 'Français', ngLocaleData: ng_fr_FR, extra: { nzLocaleData: fr_FR } },
            { localeId: 'en', localeName: 'English', ngLocaleData: ng_en_US, extra: { nzLocaleData: en_US } },
        ],
        resources: [
            { prefix: '/assets/i18n/', suffix: '.json' },
            { prefix: '/assets/i18n/', suffix: '.errors.json', key: 'errors' },
            { prefix: '/assets/i18n/', suffix: '.countries.json', key: 'countries' },
        ]
    }
}